module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xk06RO/tc-custom/9781780102375.jpg?1734326752354",
      "alt": "This image is the cover for the book Last Refuge, The Hannah Ives Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Refuge, The Hannah Ives Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Hannah can’t resist a leading role in a historical reality show, but she never expected murder to be the main theme. ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Lights, camera, murder . . . It doesn’t take much arm-twisting to persuade Hannah Ives to join the twelve-strong cast of "), _c('i', [_vm._v("Patriot House, 1774")]), _vm._v(", a reality show recreating eighteenth-century colonial life during the turbulent days leading up to the American Revolution. But when a member of the production crew is found murdered, it’s up to Hannah to change the course of history before hers is ended on live TV."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Likable Hannah is a sympathetic character who holds the cast of Patriot House and this premise-driven tale together.” —"), _c('i', [_vm._v("Booklist")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marcia Talley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Severn House\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0